import {
  RECEIVE_DELIVERY_SLOT,
  RECEIVE_DELIVERY_SLOT_ERROR,
} from '../actions/deliverySlot';

export const initialState = null;

export default function deliverySlot(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_DELIVERY_SLOT: {
      if (action.deliverySlot !== '') {
        return { ...state, ...action.deliverySlot };
      } else {
        return initialState;
      }
    }
    case RECEIVE_DELIVERY_SLOT_ERROR: {
      return { ...initialState, error: action.error };
    }
    default:
      return state;
  }
}
